import React from 'react';
import { authenticatedUser } from 'header-scripts';
import { entityUrl } from 'core-roblox-utilities';
import UserAvatarHeadshot from './UserAvatarHeadshot';
import UserInfo from './UserInfo';

function Header() {
  const { name, id, isPremiumUser, displayName } = authenticatedUser;

  const profileLink = entityUrl.user.getAbsoluteUrl(id);

  return (
    <div className='home-header'>
      <UserAvatarHeadshot userId={id} profileLink={profileLink} />
      <UserInfo
        profileLink={profileLink}
        isPremiumUser={isPremiumUser}
        name={name}
        displayName={displayName}
      />
    </div>
  );
}

export default Header;
